import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 56px;
`;

export const Submenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 0 0 140px;

  & a {
    color: #181818;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    text-decoration: none;

    &:hover {
      background-color: #ebf4ff;
    }
  }
`;

export const EntityContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
  gap: 56px;
`;

export const Entity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EntityTitle = styled.h2`
  color: #181818;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${(props) => {
    if (props.theme.mode === "dark") {
      return `
          .p-paginator {
            background: #f8f8f8;
            
            & * {
              color: black;
            }
          }
      `;
    }
  }}
`;

export const Table = styled(DataTable)`
  & thead tr th {
    padding: 15px 0;
    background: white;
    color: #181818;
    border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
    border-width: 0 0 1px 0;

    & .p-column-title {
      margin-right: 10px;
    }

    & .p-sortable-column-icon,
    & .table-sort-icon {
      display: inline-flex;
      align-items: center;
      margin-left: 10px;
      vertical-align: middle;
    }
  }

  & tbody tr td {
    padding: 12px 0;
    background: white;
    color: #181818;
    border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
    border-width: 0 0 1px 0;
  }

  && .p-datatable-tbody > tr:hover > td {
    background: #f8f8f8;
  }
`;

export const NoData = styled.div`
  width: 100%;
  height: 84px;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #5a5959;
`;

export const PaginatorBtn = styled.button`
  background: none;
  border: none;
  padding: 15px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gray};
  margin: 5px;

  &:disabled {
    color: #9fa0a4;
  }

  &:hover {
    color: #181818;
    background-color: #ebf4ff;
    border-radius: 4px;
  }
`;

export const PageReportTitle = styled.span`
  color: #181818;
  user-select: none;
  text-align: center;
  position: absolute;
  left: 0px;
`;

export const RowsPerPageWrapper = styled.div`
  position: absolute;
  right: 0px;
  display: inline-flex;
  align-items: center;
`;

export const RowsPerPage = styled(Dropdown)`
  min-width: 76px;

  &.p-dropdown {
    height: 38px;
    border: 1px solid ${({ theme }) => theme.searchPatients.controls.tabOutline};
    border-radius: 8px;
    background: #ffffff;
    box-shadow: none;
  }

  & .p-dropdown-label {
    padding: 8px 8px 8px 12px;
    color: #181818;
    font-size: 14px;
    line-height: 20px;
  }

  & .p-dropdown-trigger {
    width: 32px;
    color: #5a5959;
  }

  &:not(.p-disabled).p-focus,
  &:not(.p-disabled):hover {
    border-color: #065fa6;
    box-shadow: 0 0 0 1px rgba(6, 95, 166, 0.12);
  }
`;

export const ViewButton = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #005fb8;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  & i {
    font-size: 16px;
  }
`;

export const PaginatorWrapper = styled.div`
  position: relative;
  width: 390px;

  .p-paginator-pages {
    button {
      font-size: 14px;
      position: relative;
      top: -2px;
    }
  }

  .p-paginator > button {
    padding: 4px;
  }
`;

export const DocLink = styled.a`
  color: #065fa6;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background-color: #ebf4ff;
  }
`;

export const DetailsLink = styled(NavLink)`
  color: #181818;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
